import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { useLayout } from 'src/routes/RouteList';
import { useOnScreen } from '../../hooks/on-screen.hook';

export const Logo = (): React.ReactElement => {
    const { isApplicationLayout, isHomePage } = useLayout();
    const { isVisble, ref } = useOnScreen();

    const className = useMemo(() => {
        if (isApplicationLayout) {
            return 'logo application';
        }
        if (isHomePage) {
            return 'logo home';
        }
        return 'logo';
    }, [isApplicationLayout, isHomePage]);

    return (
        <div className={isVisble ? 'logo-on-screen' : ''}>
            <Link to="/" className="d-block logo-link">
                <img className={className} />
            </Link>
            <div className="logo-on-screen-helper" ref={ref} />
        </div>
    );
};
